<div class="cont">
  <div class="pic">
    <img src="assets/img/guidance2.png"/>
    <canvas id="canvas" class="canvas"></canvas>
  </div>
  <div class="pic">
    <img src="assets/img/guidance3.png"/>
  </div>
</div>